import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { Menu, Phone, Mail } from 'lucide-react';
import AutoMatsLogo from './AutoMatsLogo';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Products', href: '/products' },
    { name: 'Our Story', href: '/brand-story' },
    { name: 'Rescue Hub', href: '/dealer-hub' },
    { name: 'Impact', href: '/impact' }
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-automats-steel text-white py-2 px-4 text-sm font-body">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span>800-570-0704</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4" />
              <span>sales@automats.us</span>
            </div>
          </div>
          <div className="hidden md:block">
            <span className="text-automats-eco-green font-medium">40+ Years of American Excellence</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <AutoMatsLogo />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`font-body font-medium transition-colors duration-200 hover:text-automats-red ${
                    isActive(item.href) 
                      ? 'text-automats-red border-b-2 border-automats-red pb-1' 
                      : 'text-automats-black'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* CTA Buttons */}
            <div className="hidden md:flex items-center space-x-4">
              <a
                href="mailto:sales@automats.us?subject=Pricing Request&body=Hello, I would like to request pricing information for AutoMats products."
                className="border border-automats-red text-automats-red hover:bg-automats-red hover:text-white font-body px-4 py-2 rounded-md transition-colors"
              >
                Get Pricing
              </a>
              <a
                href="mailto:sales@automats.us?subject=Sample Request&body=Hello, I would like to request product samples."
                className="border border-automats-steel text-automats-steel hover:bg-automats-steel hover:text-white hover:border-automats-steel font-body px-4 py-2 rounded-md transition-all duration-200"
              >
                Request Samples
              </a>
            </div>

            {/* Mobile Menu */}
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-80">
                <div className="flex flex-col space-y-6 mt-8">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setIsOpen(false)}
                      className={`text-lg font-body font-medium transition-colors duration-200 ${
                        isActive(item.href) ? 'text-automats-red' : 'text-automats-black'
                      }`}
                    >
                      {item.name}
                    </Link>
                  ))}
                  <div className="border-t pt-6 space-y-4">
                    <a
                      href="mailto:sales@automats.us?subject=Pricing Request&body=Hello, I would like to request pricing information for AutoMats products."
                      className="w-full border border-automats-red text-automats-red hover:bg-automats-red hover:text-white font-body px-4 py-2 rounded-md transition-colors text-center block"
                    >
                      Get Pricing
                    </a>
                    <a
                      href="mailto:sales@automats.us?subject=Sample Request&body=Hello, I would like to request product samples."
                      className="w-full border border-automats-steel text-automats-steel hover:bg-automats-steel hover:text-white hover:border-automats-steel font-body px-4 py-2 rounded-md transition-all duration-200 text-center block"
                    >
                      Request Samples
                    </a>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;